import { useCallback } from "react";
import type { PaywallPrice } from "@/react/types/Paywall";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Fieldset } from "@circle-react-uikit/Fieldset";
import { Typography } from "@circle-react-uikit/Typography";
import { EventDetails } from "../../../PaywallPrice/EventDetails";
import { getPaywallTitle } from "../../../helpers/paywalls";
import { getPaywallDescription } from "../../../helpers/paywalls";
import { PaywallDescription } from "../PaywallDescription";
import { PriceDescription } from "./PriceDescription";
import { RadioOption } from "./RadioOption";

export const PriceSelector = () => {
  const { paywall, setSelectedPrice, isSelectedPrice } =
    usePaywallCheckoutContext();

  const title = getPaywallTitle(paywall);
  const description = getPaywallDescription(paywall);
  const onPriceChangeHandler = useCallback(
    (priceId: number) => {
      setSelectedPrice(priceId);
    },
    [setSelectedPrice],
  );

  return (
    <div className="flex flex-col gap-8">
      <div
        className="flex flex-col gap-3"
        data-testid="checkout-paywall-detail"
      >
        <Typography.LabelLg weight="semibold">
          <span className="text-xl">{title}</span>
        </Typography.LabelLg>
        <EventDetails event={paywall.event} />
        <PaywallDescription description={description} />
      </div>
      <Fieldset
        divProps={{
          className: "border border-primary rounded-xl divide-y flex flex-col",
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onPriceChangeHandler(Number(event.target.id))
        }
      >
        {paywall.prices.map((price: PaywallPrice) => (
          <RadioOption
            key={`paywall_price-${price.id}`}
            id={price.id.toString()}
            value={price.value}
            isSelected={isSelectedPrice(price)}
            label={<PriceDescription paywall={paywall} price={price} />}
          />
        ))}
      </Fieldset>
    </div>
  );
};
